export default {
};



// WEBPACK FOOTER //
// ./src/store/modules/favourites/mutations.js